import type {
    DeleteQuickFilterRequest,
    QuickFilter,
} from "@amzn/ads-blink-client";
import type { AsyncState, UseAsyncActions } from "@react-hookz/web";
import { useAsync } from "@react-hookz/web";

import { getBlinkApiClientV2 } from "../../../../api/blinkApi/blinkApi";
import { useAsyncErrorStatusNotification } from "../../../../hooks/notifications/useAsyncErrorStatusNotification";

export function DeleteQuickFilterActionAsync(): [
    AsyncState<boolean | undefined>,
    UseAsyncActions<boolean, [QuickFilter]>,
] {
    const [state, action] = useAsync(async (toDelete: QuickFilter) => {
        // If we ever add in more alias types, we will need to have the alias as an argument instead of hard-coding it
        const request: DeleteQuickFilterRequest = {
            alias: toDelete.alias,
            identifier: toDelete.identifier,
        };

        try {
            await (await getBlinkApiClientV2()).deleteQuickFilter(request);
            return true;
        } catch (error) {
            console.error("Failed to delete quickfilter", error);
            throw new Error(
                "Failed to delete Quick Filter. Please try again, or contact support if the issue persists.",
            );
        }
    });

    // Alert the user of any errors we run into
    useAsyncErrorStatusNotification(state);

    return [state, action];
}
